import apiFinancial from "../config/api_financial";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiFinancial = axios.create({
//   baseURL: "http://localhost:8086",
// });

export function indexAllFinancialIssue(payload) {
  const { groupId, farmId, signal } = payload;

  return apiFinancial.get(
    `/bovexo/${groupId}/farms/${farmId}/financial/issues`,
    getHeaders(false, signal)
  );
}

export function indexAllDropdownFinancialIssue(payload) {
  const { groupId, farmId, signal } = payload;

  return apiFinancial.get(
    `/bovexo/${groupId}/farms/${farmId}/financial/issues`,
    getHeaders(false, signal)
  );
}

export function saveOrUpdateFinancialIssue(payload) {
  const { groupId, farmId, id, body, signal } = payload;

  if (id)
    if (body.farmId)
      return apiFinancial.patch(
        `/bovexo/${groupId}/farms/${farmId}/financial/issues/${id}`,
        body,
        getHeaders(false, signal)
      );
    else
      return apiFinancial.patch(
        `/bovexo/${groupId}/farms/financial/issues/${id}`,
        body,
        getHeaders(false, signal)
      );
  else if (body.farmId)
    return apiFinancial.post(
      `/bovexo/${groupId}/farms/${farmId}/financial/issues`,
      body,
      getHeaders(false, signal)
    );
  return apiFinancial.post(
    `/bovexo/${groupId}/farms/financial/issues`,
    body,
    getHeaders(false, signal)
  );
}

export function activateFinancialIssue(payload) {
  const { groupId, farmId, id, signal } = payload;
  return apiFinancial.patch(
    `/bovexo/${groupId}/farms/${farmId}/financial/issues/${id}/activate`,
    null,
    getHeaders(false, signal)
  );
}

export function inactivateFinancialIssue(payload) {
  const { groupId, farmId, id, signal } = payload;
  return apiFinancial.patch(
    `/bovexo/${groupId}/farms/${farmId}/financial/issues/${id}/inactivate`,
    null,
    getHeaders(false, signal)
  );
}
